import { render, staticRenderFns } from "./KolonneSettingsCrudEmployeesRankingLegend.vue?vue&type=template&id=925b0d3e"
import script from "./KolonneSettingsCrudEmployeesRankingLegend.vue?vue&type=script&lang=js"
export * from "./KolonneSettingsCrudEmployeesRankingLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports